import axios from 'axios';
import { localStorage as localStorageConstants } from 'constants/index';
import * as qs from 'qs';
import { push } from 'connected-react-router';
import { normalizeMyTagData, transformCategoryToTags } from 'utils/manipulate';
import resolvePath from 'utils/resolvePath';
import { store } from 'store/store';
// Action
const FORWARD = 'teachers/forward';
const BACK = 'teachers/back';
const CONFIRM = 'teachers/confirm';
const CANCEL = 'teachers/cancel';
const REGISTER = 'teachers/register';
const RESET_INFO = 'teachers/resetInfo';
const CLEAR_ERROR = 'teachers/clearError';
const CLEAR_OTHER_USER = 'teachers/clearOtherUser';
const SET_CURRENT_PASSWORD = 'teachers/setCurrentPassword';
const GET_TAGS_REQUEST = 'students/getTagsRequest';
const GET_TAGS_SUCCESS = 'students/getTagsSuccess';
const GET_TAGS_FAILURE = 'students/getTagsFailure';
const GET_PURPOSES_REQUEST = 'teachers/getPurposesRequest';
const GET_PURPOSES_SUCCESS = 'teachers/getPurposesSuccess';
const GET_PURPOSES_FAILURE = 'teachers/getPurposesFailure';
const POST_ME_REQUEST = 'teachers/postMeRequest';
const POST_ME_SUCCESS = 'teachers/postMeSuccess';
const POST_ME_FAILURE = 'teachers/postMeFailure';
const POST_SIGNIN_REQUEST = 'teachers/postSigninRequest';
const POST_SIGNIN_SUCCESS = 'teachers/postSigninSuccess';
const POST_SIGNIN_FAILURE = 'teachers/postSigninFailure';
const GET_ME_REQUEST = 'teachers/getMeRequest';
const GET_ME_SUCCESS = 'teachers/getMeSuccess';
const GET_ME_FAILURE = 'teachers/getMeFailure';
const PATCH_ME_REQUEST = 'teachers/patchMeRequest';
const PATCH_ME_SUCCESS = 'teachers/patchMeSuccess';
const PATCH_ME_FAILURE = 'teachers/patchMeFailure';
const POST_VALIDATE_REQUEST = 'teachers/postValidateRequest';
const POST_VALIDATE_SUCCESS = 'teachers/postValidateSuccess';
const POST_VALIDATE_FAILURE = 'teachers/postValidateFailure';
const DELETE_SIGNOUT_REQUEST = 'teachers/deleteSignoutRequest';
const DELETE_SIGNOUT_SUCCESS = 'teachers/deleteSignoutSuccess';
const DELETE_SIGNOUT_FAILURE = 'teachers/deleteSignoutFailure';
const POST_PASSWORD_REQUEST = 'teachers/postPasswordRequest';
const POST_PASSWORD_SUCCESS = 'teachers/postPasswordSuccess';
const POST_PASSWORD_FAILURE = 'teachers/postPasswordFailure';
const PATCH_PASSWORD_REQUEST = 'teachers/patchPasswordRequest';
const PATCH_PASSWORD_SUCCESS = 'teachers/patchPasswordSuccess';
const PATCH_PASSWORD_FAILURE = 'teachers/patchPasswordFailure';
const GET_TEACHER_REQUEST = 'teachers/getTeacherRequest';
const GET_TEACHER_SUCCESS = 'teachers/getTeacherSuccess';
const GET_TEACHER_FAILURE = 'teachers/getTeacherFailure';
const GET_BILLING_REQUEST = 'students/getBillingRequest';
const GET_BILLING_SUCCESS = 'students/getBillingSuccess';
const GET_BILLING_FAILURE = 'students/getBillingFailure';
const GET_RECENT_USERS = 'teachers/getRecentUsers';
const GET_RECENTLY_REQUEST = 'teachers/getRecentlyRequest';
const GET_RECENTLY_SUCCESS = 'teachers/getRecentlySuccess';
const GET_RECENTLY_FAILURE = 'teachers/getRecentlyFailure';
const GET_HAVE_CONVERSATIONS_REQUEST = 'teachers/getHaveConversationsRequest';
const GET_HAVE_CONVERSATIONS_SUCCESS = 'teachers/getHaveConversationsSuccess';
const GET_HAVE_CONVERSATIONS_FAILURE = 'teachers/getHaveConversationsFailure';
const GET_RECENTLY_RESERVABLE_REQUEST = 'teachers/getRecentlyReservableRequest';
const GET_RECENTLY_RESERVABLE_SUCCESS = 'teachers/getRecentlyReservableSuccess';
const GET_RECENTLY_RESERVABLE_FAILURE = 'teachers/getRecentlyReservableFailure';
const GET_ACHIEVEMENTS_REQUEST = 'teachers/getAchievementsRequest';
const GET_ACHIEVEMENTS_SUCCESS = 'teachers/getAchievementsSuccess';
const GET_ACHIEVEMENTS_FAILURE = 'teachers/getAchievementsFailure';
const RESET_ACHIEVEMENTS = 'teachers/resetAchievements';
const GET_DONATION_REQUEST = 'teachers/getDonationRequest';
const GET_DONATION_SUCCESS = 'teachers/getDonationSuccess';
const GET_DONATION_FAILURE = 'teachers/getDonationFailure';
const RESET_DONATION = 'teachers/resetDonation';
const DELETE_TEACHER = 'teachers/delete';
const DELETE_TEACHER_REQUEST = 'teachers/deleteRequest';
const DELETE_TEACHER_SUCCESS = 'teachers/deleteSuccess';
const DELETE_TEACHER_FAILURE = 'teachers/deleteFailure';
export const forward = (step) => {
    return {
        step: step ? step : -1,
        type: FORWARD,
    };
};
export const back = () => {
    return {
        type: BACK,
    };
};
export const confirm = () => {
    return {
        type: CONFIRM,
    };
};
export const cancel = () => {
    return {
        type: CANCEL,
    };
};
export const register = (info) => {
    return {
        payload: {
            info,
        },
        type: REGISTER,
    };
};
export const resetInfo = () => {
    return {
        type: RESET_INFO,
    };
};
export const clearError = () => {
    return {
        type: CLEAR_ERROR,
    };
};
export const clearOtherUser = () => {
    return {
        type: CLEAR_OTHER_USER,
    };
};
export const setCurrentPassword = (currentPassword) => {
    return {
        payload: {
            current_password: currentPassword,
        },
        type: SET_CURRENT_PASSWORD,
    };
};
export const getTagsRequest = () => {
    return {
        type: GET_TAGS_REQUEST,
    };
};
export const getTagsSuccess = (tags) => {
    return {
        payload: {
            tags,
        },
        type: GET_TAGS_SUCCESS,
    };
};
export const getTagsFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_TAGS_FAILURE,
    };
};
export const getTags = () => {
    return (dispatch) => {
        dispatch(getTagsRequest());
        return axios
            .get(resolvePath.api('categories'))
            .then((response) => dispatch(getTagsSuccess(transformCategoryToTags('ja')(response.data.categories))))
            .catch((error) => {
            dispatch(getTagsFailure(Response.error));
            throw error;
        });
    };
};
export const getPurposesRequest = () => {
    return {
        type: GET_PURPOSES_REQUEST,
    };
};
export const getPurposesSuccess = (purposes) => {
    return {
        payload: {
            purposes,
        },
        type: GET_PURPOSES_SUCCESS,
    };
};
export const getPurposesFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_PURPOSES_FAILURE,
    };
};
export const getPurposes = () => {
    return (dispatch) => {
        dispatch(getPurposesRequest());
        return axios
            .get(resolvePath.api('teachers/purposes'))
            .then((response) => dispatch(getPurposesSuccess(response.data)))
            .catch((error) => {
            dispatch(getPurposesFailure(error));
            throw new Error();
        });
    };
};
export const postMeRequest = () => {
    return {
        type: POST_ME_REQUEST,
    };
};
export const postMeSuccess = (me) => {
    return {
        payload: {
            me,
        },
        type: POST_ME_SUCCESS,
    };
};
export const postMeFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: POST_ME_FAILURE,
    };
};
export const postMe = (teacher) => {
    return (dispatch) => {
        dispatch(postMeRequest());
        return axios
            .post(resolvePath.api('teachers'), teacher)
            .then((response) => {
            dispatch(postMeSuccess(response.data));
            if (response.data.auth_token) {
                localStorage.setItem(localStorageConstants.TEACHERS_AUTH_TOKEN_KEY, response.data.auth_token);
                localStorage.setItem(localStorageConstants.WEB_SOCKET_TOKEN_KEY, response.data.web_socket_token);
                localStorage.setItem(localStorageConstants.USERS_EMAIL, response.data.email);
            }
        })
            .catch((error) => {
            dispatch(postMeFailure(error));
            throw error;
        });
    };
};
export const postSigninRequest = () => {
    return {
        type: POST_SIGNIN_REQUEST,
    };
};
export const postSigninSuccess = (me) => {
    return {
        payload: {
            me,
        },
        type: POST_SIGNIN_SUCCESS,
    };
};
export const postSigninFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: POST_SIGNIN_FAILURE,
    };
};
export const postSignin = (signin) => {
    return (dispatch) => {
        dispatch(postSigninRequest());
        return axios
            .post(resolvePath.api('teachers/signin'), signin)
            .then((response) => {
            dispatch(postSigninSuccess(normalizeMyTagData('ja')(response.data)));
            if (response.data.auth_token) {
                localStorage.setItem(localStorageConstants.TEACHERS_AUTH_TOKEN_KEY, response.data.auth_token);
                localStorage.setItem(localStorageConstants.WEB_SOCKET_TOKEN_KEY, response.data.web_socket_token);
                localStorage.setItem(localStorageConstants.USERS_EMAIL, response.data.email);
            }
        })
            .catch((error) => {
            dispatch(postSigninFailure(error));
            throw error;
        });
    };
};
export const getMeRequest = () => {
    return {
        type: GET_ME_REQUEST,
    };
};
export const getMeSuccess = (me) => {
    return {
        payload: {
            me,
        },
        type: GET_ME_SUCCESS,
    };
};
export const getMeFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_ME_FAILURE,
    };
};
export const getMe = (authToken) => {
    return (dispatch) => {
        dispatch(getMeRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        return axios
            .get(resolvePath.api('teachers/me'), config)
            .then((response) => {
            dispatch(getMeSuccess(normalizeMyTagData('ja')(response.data)));
            if (response.data.auth_token) {
                localStorage.setItem(localStorageConstants.TEACHERS_AUTH_TOKEN_KEY, response.data.auth_token);
                localStorage.setItem(localStorageConstants.WEB_SOCKET_TOKEN_KEY, response.data.web_socket_token);
            }
        })
            .catch((error) => {
            dispatch(getMeFailure(error));
            throw error;
        });
    };
};
export const patchMeRequest = () => {
    return {
        type: PATCH_ME_REQUEST,
    };
};
export const patchMeSuccess = (me) => {
    return {
        payload: {
            me,
        },
        type: PATCH_ME_SUCCESS,
    };
};
export const patchMeFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: PATCH_ME_FAILURE,
    };
};
export const patchMe = (authToken, changes) => {
    return (dispatch) => {
        dispatch(patchMeRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        return axios
            .patch(resolvePath.api('teachers/me'), changes, config)
            .then((response) => {
            dispatch(patchMeSuccess(normalizeMyTagData('ja')(response.data)));
            dispatch(push(resolvePath.page('teachers', 'profile/edit')));
        })
            .catch((error) => {
            dispatch(patchMeFailure(error));
            throw error;
        });
    };
};
export const postValidateRequest = () => {
    return {
        type: POST_VALIDATE_REQUEST,
    };
};
export const postValidateSuccess = (validation) => {
    return {
        payload: {
            validation,
        },
        type: POST_VALIDATE_SUCCESS,
    };
};
export const postValidateFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: POST_VALIDATE_FAILURE,
    };
};
export const postValidate = (request) => (dispatch) => {
    dispatch(postValidateRequest());
    return axios
        .post(resolvePath.api('teachers/validate'), request)
        .then((response) => dispatch(postValidateSuccess(response.data)))
        .catch((error) => {
        dispatch(postValidateFailure(error));
        throw error;
    });
};
export const deleteSignoutRequest = () => {
    return {
        type: DELETE_SIGNOUT_REQUEST,
    };
};
export const deleteSignoutSuccess = () => {
    return {
        type: DELETE_SIGNOUT_SUCCESS,
    };
};
export const deleteSignoutFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: DELETE_SIGNOUT_FAILURE,
    };
};
export const deleteSignout = (authToken) => (dispatch) => {
    dispatch(deleteSignoutRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios
        .delete(resolvePath.api('teachers/signout'), config)
        .then(() => dispatch(deleteSignoutSuccess()))
        .catch((error) => {
        dispatch(deleteSignoutFailure(error));
        throw error;
    });
};
export const postPasswordRequest = () => {
    return {
        type: POST_PASSWORD_REQUEST,
    };
};
export const postPasswordSuccess = () => {
    return {
        type: POST_PASSWORD_SUCCESS,
    };
};
export const postPasswordFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: POST_PASSWORD_FAILURE,
    };
};
export const postPassword = (email) => (dispatch) => {
    dispatch(postPasswordRequest());
    const request = {
        email,
    };
    return axios
        .post(resolvePath.api('teachers/password'), request)
        .then(() => dispatch(postPasswordSuccess()))
        .catch((error) => {
        dispatch(postPasswordFailure(error));
        throw error;
    });
};
export const patchPasswordRequest = () => {
    return {
        type: PATCH_PASSWORD_REQUEST,
    };
};
export const patchPasswordSuccess = () => {
    return {
        type: PATCH_PASSWORD_SUCCESS,
    };
};
export const patchPasswordFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: PATCH_PASSWORD_FAILURE,
    };
};
export const patchPassword = (token, password) => (dispatch) => {
    dispatch(patchPasswordRequest());
    const request = {
        password,
        token,
    };
    return axios
        .patch(resolvePath.api('teachers/password'), request)
        .then(() => dispatch(patchPasswordSuccess()))
        .catch((error) => {
        dispatch(patchPasswordFailure(error));
        throw error;
    });
};
export const getTeacherRequest = () => {
    return {
        type: GET_TEACHER_REQUEST,
    };
};
export const getTeacherSuccess = (otherUser) => {
    return {
        payload: {
            otherUser,
        },
        type: GET_TEACHER_SUCCESS,
    };
};
export const getTeacherFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_TEACHER_FAILURE,
    };
};
export const getTeacher = (authToken, teacherId, selfId) => {
    return (dispatch) => {
        dispatch(getTeacherRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        const getTeacherDataPromise = axios.get(resolvePath.api(`teachers/${teacherId}`), config);
        const getTeacherMemoPromise = axios.get(`teachers/${teacherId}/memos?${qs.stringify({ selfId })}`, config);
        return Promise.all([getTeacherDataPromise, getTeacherMemoPromise])
            .then(([teacherDataResponse, teacherMemoResponse]) => {
            const otherUserData = Object.assign(Object.assign({}, teacherDataResponse.data), { memo: teacherMemoResponse.data });
            dispatch(getTeacherSuccess(otherUserData));
        })
            .catch((error) => {
            dispatch(getTeacherFailure(error));
            throw error;
        });
    };
};
export const getBillingRequest = () => {
    return {
        type: GET_BILLING_REQUEST,
    };
};
export const getBillingSuccess = (billing_details) => {
    return {
        payload: {
            billing_details,
        },
        type: GET_BILLING_SUCCESS,
    };
};
export const getBillingFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_BILLING_FAILURE,
    };
};
export const getBilling = (authToken) => (dispatch) => {
    dispatch(getBillingRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios
        .get(resolvePath.api('teachers/get_billing'), config)
        .then((response) => dispatch(getBillingSuccess(response.data)))
        .catch((error) => {
        dispatch(getBillingFailure(error));
        throw error;
    });
};
export const getRecentlyRequest = () => {
    return {
        type: GET_RECENTLY_REQUEST,
    };
};
export const getRecentlySuccess = (users) => {
    return {
        payload: {
            users,
        },
        type: GET_RECENTLY_SUCCESS,
    };
};
export const getRecentlyFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_RECENTLY_FAILURE,
    };
};
export const getRecently = (authToken) => {
    const loadRecentUsers = (dispatch) => {
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        return axios
            .get(resolvePath.api('teachers/recently'), config)
            .then((response) => dispatch(getRecentlySuccess(response.data ? response.data.data : [])))
            .catch((error) => {
            dispatch(getRecentlyFailure(error));
            throw new Error();
        });
    };
    loadRecentUsers(store.dispatch);
    return {
        type: GET_RECENT_USERS,
    };
};
export const getHaveConversationsRequest = () => {
    return {
        type: GET_HAVE_CONVERSATIONS_REQUEST,
    };
};
export const getHaveConversationsSuccess = (users) => {
    return {
        payload: {
            users,
        },
        type: GET_HAVE_CONVERSATIONS_SUCCESS,
    };
};
export const getHaveConversationsFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_HAVE_CONVERSATIONS_FAILURE,
    };
};
export const getHaveConversations = (authToken) => {
    return (dispatch) => {
        dispatch(getHaveConversationsRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        return axios
            .get(resolvePath.api('teachers/have_conversations'), config)
            .then((response) => dispatch(getHaveConversationsSuccess(response.data ? response.data.data : [])))
            .catch((error) => {
            dispatch(getHaveConversationsFailure(error));
            throw new Error();
        });
    };
};
export const getRecentlyReservableRequest = () => {
    return {
        type: GET_RECENTLY_RESERVABLE_REQUEST,
    };
};
export const getRecentlyReservableSuccess = (reservables) => {
    return {
        payload: {
            reservables,
        },
        type: GET_RECENTLY_RESERVABLE_SUCCESS,
    };
};
export const getRecentlyReservableFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_RECENTLY_RESERVABLE_FAILURE,
    };
};
export const getRecentlyReservable = (authToken) => {
    return (dispatch) => {
        dispatch(getRecentlyReservableRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
            params: { per_page: 7 },
        };
        return axios
            .get(resolvePath.api('teachers/recently_reservable'), config)
            .then((response) => dispatch(getRecentlyReservableSuccess(response.data)))
            .catch((error) => {
            dispatch(getRecentlyReservableFailure(error));
            throw new Error();
        });
    };
};
export const getAchievementsRequest = () => {
    return {
        type: GET_ACHIEVEMENTS_REQUEST,
    };
};
export const getAchievementsSuccess = (achievements) => {
    return {
        payload: {
            achievements,
        },
        type: GET_ACHIEVEMENTS_SUCCESS,
    };
};
export const getAchievementstFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_ACHIEVEMENTS_FAILURE,
    };
};
export const getAchievements = (authToken, userId) => {
    return (dispatch) => {
        dispatch(getAchievementsRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
            params: { user_id: userId },
        };
        return axios
            .get(resolvePath.api('teachers/achievements'), config)
            .then((response) => {
            dispatch(getAchievementsSuccess(response.data));
        })
            .catch((error) => {
            dispatch(getAchievementstFailure(error));
            throw error;
        });
    };
};
export const resetAchievements = () => {
    return {
        type: RESET_ACHIEVEMENTS,
    };
};
export const getDonationRequest = () => {
    return {
        type: GET_DONATION_REQUEST,
    };
};
export const getDonationSuccess = (donation) => {
    return {
        payload: {
            donation,
        },
        type: GET_DONATION_SUCCESS,
    };
};
export const getDonationFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_DONATION_FAILURE,
    };
};
export const getDonation = (authToken, userId) => {
    return (dispatch) => {
        dispatch(getDonationRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
            params: { user_id: userId },
        };
        return axios
            .get(resolvePath.api('teachers/donation'), config)
            .then((response) => {
            dispatch(getDonationSuccess(response.data));
        })
            .catch((error) => {
            dispatch(getDonationFailure(error));
            throw error;
        });
    };
};
export const resetDonation = () => {
    return {
        type: RESET_DONATION,
    };
};
export const deleteTeacherRequest = () => {
    return {
        type: DELETE_TEACHER_REQUEST,
    };
};
export const deleteTeacherSuccess = () => {
    return {
        type: DELETE_TEACHER_SUCCESS,
    };
};
export const deleteTeacherFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: DELETE_TEACHER_FAILURE,
    };
};
export const deleteTeacher = (authToken) => {
    const deleteCurrentStudent = (dispatch) => {
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        return axios
            .delete(resolvePath.api('teachers/me'), config)
            .then(() => dispatch(deleteTeacherSuccess()))
            .catch((error) => {
            dispatch(deleteTeacherFailure(error));
            throw new Error('アカウント削除中、エラーが発生しました。');
        });
    };
    deleteCurrentStudent(store.dispatch);
    return {
        type: DELETE_TEACHER,
    };
};
const initialInfoState = {
    custom_gender: '',
    desiredCondition: '',
    email: '',
    gender: '',
    tags: [],
    introduce: '',
    name: '',
    password: '',
    picture: '',
    prefecture: 0,
    preferred_name: 1,
    purposes: [],
};
const initialMeState = {
    absence: 0,
    auth_token: '',
    birthday: '',
    conversation_level: null,
    conversations: [],
    country: '',
    custom_gender: '',
    desired_condition: 2,
    email: '',
    evaluate: {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
    },
    employment_hope: 0,
    grade: null,
    id: 0,
    introduce: '',
    lateness: 0,
    level: null,
    location: '',
    plus_user: false,
    name: '',
    name_ja: '',
    nationality: '',
    organization_device: null,
    organization_sections: [],
    organizations: [],
    picture_url: '',
    prefecture: 0,
    preferred_name: 1,
    purposes: [],
    rated_conversation_level: null,
    sex: 0,
    tags: [],
    timezone: '',
    timezone_in_japanese: '',
    type: '',
    username: '',
    web_socket_token: '',
    subscribing: false,
    confirmed: false,
    unConfirmedEmail: '',
};
const initialAchievementsState = {
    running_days: 0,
    week_days_conversation_time: [0, 0, 0, 0, 0, 0, 0],
    stats: {
        weekly: {
            total_time: 0,
            conversation_count: 0,
            partner_count: 0,
            recently_partners: [],
        },
        monthly: {
            total_time: 0,
            conversation_count: 0,
            partner_count: 0,
            recently_partners: [],
        },
        total: {
            total_time: 0,
            conversation_count: 0,
            partner_count: 0,
            recently_partners: [],
        },
    },
};
const initialDonationState = {
    amount: 0,
};
const initialState = {
    current_password: '',
    error: null,
    tags: [],
    info: initialInfoState,
    isFetching: false,
    isPasswordRenewed: false,
    me: initialMeState,
    otherUser: null,
    purposes: [],
    sentPasswordResetRequest: false,
    showConfirmation: false,
    step: 1,
    validation: null,
    billing_details: [],
    recentlyUsers: [],
    conversationedUsers: [],
    recentlyReservables: [],
    achievements: initialAchievementsState,
    donation: initialDonationState,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case FORWARD: {
            if (action.step < 0) {
                return Object.assign(Object.assign({}, state), { step: state.step < 7 ? state.step + 1 : state.step });
            }
            else {
                return Object.assign(Object.assign({}, state), { step: action.step < 8 ? action.step : 6 });
            }
        }
        case BACK: {
            return Object.assign(Object.assign({}, state), { step: state.step > 1 ? state.step - 1 : state.step });
        }
        case CONFIRM: {
            return Object.assign(Object.assign({}, state), { showConfirmation: true });
        }
        case CANCEL: {
            return Object.assign(Object.assign({}, state), { showConfirmation: false });
        }
        case REGISTER: {
            return Object.assign(Object.assign({}, state), { error: null, info: Object.assign({}, action.payload.info) });
        }
        case RESET_INFO: {
            return Object.assign(Object.assign({}, state), { info: Object.assign({}, initialInfoState), step: 1 });
        }
        case CLEAR_ERROR: {
            return Object.assign(Object.assign({}, state), { error: null });
        }
        case CLEAR_OTHER_USER: {
            return Object.assign(Object.assign({}, state), { otherUser: null });
        }
        case SET_CURRENT_PASSWORD: {
            return Object.assign(Object.assign({}, state), { current_password: action.payload.current_password });
        }
        case GET_TAGS_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_TAGS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { tags: action.payload.tags, isFetching: false });
        }
        case GET_TAGS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case GET_PURPOSES_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_PURPOSES_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, purposes: action.payload.purposes });
        }
        case GET_PURPOSES_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case POST_ME_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case POST_ME_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, me: Object.assign({}, action.payload.me) });
        }
        case POST_ME_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case POST_SIGNIN_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case POST_SIGNIN_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, me: Object.assign({}, action.payload.me) });
        }
        case POST_SIGNIN_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case GET_ME_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_ME_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, me: Object.assign({}, action.payload.me) });
        }
        case GET_ME_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case PATCH_ME_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case PATCH_ME_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, me: Object.assign({}, action.payload.me) });
        }
        case PATCH_ME_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case POST_VALIDATE_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case POST_VALIDATE_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, validation: action.payload.validation });
        }
        case POST_VALIDATE_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case DELETE_SIGNOUT_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case DELETE_SIGNOUT_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false });
        }
        case DELETE_SIGNOUT_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case POST_PASSWORD_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case POST_PASSWORD_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, sentPasswordResetRequest: true });
        }
        case POST_PASSWORD_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case PATCH_PASSWORD_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case PATCH_PASSWORD_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, isPasswordRenewed: true });
        }
        case PATCH_PASSWORD_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case GET_TEACHER_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_TEACHER_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, otherUser: Object.assign({}, action.payload.otherUser) });
        }
        case GET_TEACHER_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case GET_BILLING_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_BILLING_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, billing_details: action.payload.billing_details });
        }
        case GET_BILLING_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case GET_RECENTLY_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_RECENTLY_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, recentlyUsers: action.payload.users });
        }
        case GET_RECENTLY_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case GET_HAVE_CONVERSATIONS_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_HAVE_CONVERSATIONS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, conversationedUsers: action.payload.users });
        }
        case GET_HAVE_CONVERSATIONS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case GET_RECENTLY_RESERVABLE_REQUEST: {
            return Object.assign({}, state);
        }
        case GET_RECENTLY_RESERVABLE_SUCCESS: {
            return Object.assign(Object.assign({}, state), { recentlyReservables: action.payload.reservables });
        }
        case GET_RECENTLY_RESERVABLE_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error });
        }
        case GET_ACHIEVEMENTS_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_ACHIEVEMENTS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, achievements: action.payload.achievements });
        }
        case GET_ACHIEVEMENTS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case RESET_ACHIEVEMENTS: {
            return Object.assign(Object.assign({}, state), { achievements: initialAchievementsState });
        }
        case GET_DONATION_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_DONATION_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, donation: action.payload.donation });
        }
        case GET_DONATION_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case RESET_DONATION: {
            return Object.assign(Object.assign({}, state), { donation: initialDonationState });
        }
        default: {
            return state;
        }
    }
};
